import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
} from "../_helpers/ApiThunk";

const initialState = {
  getShopListData: {},
  createData: {},
  editData: {},
  enableDisableData: {},
  getGeneralDataApi: {},
  getMetaDataApi: {},
  getMediaDataApi: {},
  editGeneralDataApi: {},
  editMediaDataApi: {},
  getBankDataApi: {},
  getReturnAddressListData: {},
  checkAlternateBankDataApi: {},
};

export const getShopList = createApiThunkPrivate(
  "getShopList",
  "/store/getList",
  "GET"
);
export const create = createApiThunkPrivate("create", "/store/create", "POST");
export const edit = createApiThunkPrivate("const", "/store/update", "PUT");
export const enableDisable = createApiThunkPrivate(
  "enableDisable",
  "/store/enableDisable",
  "PUT"
);
// export const getAllCountryList = createApiThunkPrivate('getAllCountryList', '/store/getAllDocuments', 'GET')

export const getGeneralData = createApiThunkPrivate(
  "getGeneralData",
  "/seller-store/general-data",
  "GET"
);
export const getMetaData = createApiThunkPrivate(
  "getMetaData",
  "/seller-store/meta-data",
  "GET"
);
export const getMediaData = createApiThunkPrivate(
  "getMediaData",
  "/seller-store/media-data",
  "GET"
);
export const getBankData = createApiThunkPrivate(
  "getBankData",
  "/seller-store/get-bank-details",
  "GET"
);

export const changeStoreCommission = createApiThunkPrivate(
  "changeStoreCommission",
  "/store/changeStoreCommission",
  "POST"
);

export const editGeneralData = createApiThunkPrivate(
  "editGeneralData",
  "/seller-store/update-general-data",
  "POST"
);
export const editMetaData = createApiThunkPrivate(
  "editGeneralData",
  "/seller-store/update-meta-data",
  "POST"
);
export const editMediaData = createApiThunkPrivate(
  "editMediaData",
  "/seller-store/update-media-data",
  "POST"
);
export const editBankData = createApiThunkPrivate(
  "editMediaData",
  "/seller-store/update-bank-details",
  "POST"
);
export const getReturnAddressList = createApiThunkPrivate(
  "getReturnAddressList",
  "/seller-store/return-address-list",
  "POST"
);
export const createReturnAddress = createApiThunkPrivate(
  "createReturnAddress",
  "/seller-store/create-return-address",
  "POST"
);
export const updateReturnAddress = createApiThunkPrivate(
  "updateReturnAddress",
  "/seller-store/update-return-address",
  "POST"
);
export const deleteReturnAddress = createApiThunkPrivate(
  "updateReturnAddress",
  "/seller-store/delete-return-address",
  "POST"
);

export const getPickupAddressList = createApiThunkPrivate(
  "getPickupAddressList",
  "/seller-store/pickup-address-list",
  "POST"
);
export const createPickupAddress = createApiThunkPrivate(
  "createReturnAddress",
  "/seller-store/create-pickup-address",
  "POST"
);
export const updatePickupAddress = createApiThunkPrivate(
  "updateReturnAddress",
  "/seller-store/update-pickup-address",
  "POST"
);
export const deletePickupAddress = createApiThunkPrivate(
  "updateReturnAddress",
  "/seller-store/delete-pickup-address",
  "POST"
);

export const changeStorePassword = createApiThunkPrivate(
  "changeStorePassword",
  "/seller-store/change-store-password",
  "POST"
);
export const verifyOtp = createApiThunkPrivate(
  "verifyOtp",
  "/seller-store/verify-store-otp",
  "POST"
);
export const resetStorePassword = createApiThunkPrivate(
  "resetStorePassword",
  "/seller-store/reset-store-password",
  "PUT"
);
export const accountSetupForPayouts = createApiThunkPrivate(
  "accountSetupForPayouts",
  "/seller-store/account-setup-for-payouts",
  "POST"
);

export const checkAlternateBankData = createApiThunkPrivate(
  "checkAlternateBankData",
  "/seller-store/check-alternate-bank-setup",
  "GET"
);

export const editAlternateBankData = createApiThunkPrivate(
  "editAlternateBankData",
  "/seller-store/update-alternate-bank-details",
  "POST"
);

const storeSlice = createSlice({
  name: "store",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(builder, getShopList, "getShopListData");
    createExtraReducersForThunk(builder, create, "createData");
    createExtraReducersForThunk(builder, edit, "editData");
    createExtraReducersForThunk(builder, enableDisable, "enableDisableData");
    // createExtraReducersForThunk(builder, getAllCountryList, 'getAllCountryListData')

    createExtraReducersForThunk(builder, getGeneralData, "getGeneralDataApi");
    createExtraReducersForThunk(builder, getMetaData, "getMetaDataApi");
    createExtraReducersForThunk(builder, getMediaData, "getMediaDataApi");
    createExtraReducersForThunk(builder, getBankData, "getBankDataApi");

    createExtraReducersForThunk(builder, editGeneralData, "editGeneralDataApi");
    createExtraReducersForThunk(builder, editMediaData, "editMediaDataApi");
    createExtraReducersForThunk(
      builder,
      getReturnAddressList,
      "getReturnAddressListData"
    );

    createExtraReducersForThunk(
      builder,
      getPickupAddressList,
      "getPickupAddressListData"
    );
    createExtraReducersForThunk(builder, verifyOtp, "verifyOtpData");
    createExtraReducersForThunk(
      builder,
      resetStorePassword,
      "resetStorePasswordData"
    );

    createExtraReducersForThunk(builder, checkAlternateBankData, "checkAlternateBankDataApi");


    // policy functions======>>>>>>>>>>>>>>
  },
});

export default storeSlice.reducer;
